import cx from "classnames";
import { mergeRefs } from "@react-aria/utils";
import { formatDistance, formatDistanceStrict } from "date-fns/esm";

import TextEllipsis from "ds/components/TextEllipsis";
import Tooltip from "ds/components/Tooltip";
import Typography, { TypographyProps } from "ds/components/Typography";
import { formatDate } from "utils/date";
import { getNowTimeMs, unixTimestampToMs } from "utils/time";
import { TooltipReferenceProps } from "ds/components/Tooltip/types";

type TimestampProps = {
  timestamp: number;
  color?: TypographyProps["color"];
  variant?: TypographyProps["variant"];
  strict?: boolean;
};

const Timestamp = ({ timestamp, color, variant = "p-body3", strict }: TimestampProps) => {
  const timestampMs = unixTimestampToMs(timestamp);
  const now = getNowTimeMs();

  const formattedTimestamp = formatDate({
    date: timestampMs,
  });

  const relativeTime = strict
    ? formatDistanceStrict(timestampMs, now, { addSuffix: true })
    : formatDistance(timestampMs, now, { addSuffix: true, includeSeconds: true });

  const tooltipText = `${formattedTimestamp} (${relativeTime})`;

  return (
    <TextEllipsis tooltip={tooltipText}>
      {(parentProps, isActive) => (
        <Tooltip
          active={!isActive}
          on={(props: TooltipReferenceProps) => (
            <Typography
              ref={mergeRefs(props.ref, parentProps.ref)}
              className={cx(props.className, parentProps.className)}
              tag="span"
              variant={variant}
              color={color}
            >
              {formattedTimestamp}
            </Typography>
          )}
        >
          {relativeTime}
        </Tooltip>
      )}
    </TextEllipsis>
  );
};

export default Timestamp;
